import { layoutTemplateList } from "../constants/layoutTemplates";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const buildCellsFromTemplate = (template) => {
  const cells = [];
  for (let row = 0; row < template.grid.rows; row += 1) {
    for (let col = 0; col < template.grid.columns; col += 1) {
      cells.push({
        cell_key: `R${row + 1}C${col + 1}`,
        row_index: row,
        col_index: col,
        row_span: 1,
        col_span: 1,
        cell_type: "normal",
      });
    }
  }
  return cells;
};

const buildLayoutFromTemplate = (template) => ({
  id: template.key,
  name: template.name,
  page_width: template.page.width,
  page_height: template.page.height,
  margin_top: template.margins.top,
  margin_bottom: template.margins.bottom,
  margin_left: template.margins.left,
  margin_right: template.margins.right,
  gutter_horiz: template.gutters.horizontal,
  gutter_vert: template.gutters.vertical,
  cells: buildCellsFromTemplate(template),
});

export async function fetchLayouts() {
  return layoutTemplateList.map(buildLayoutFromTemplate);
}

export async function createLayout(layoutData) {
  const resp = await fetch(`${API_URL}/layouts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(layoutData)
  });
  if (!resp.ok) {
    throw new Error("Failed to create layout");
  }
  return resp.json();
}
